"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.number.constructor");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _validate = require("@/utils/validate");

var _send = require("@/api/cms/send");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'DeliveryShansong',
  components: {
    CommonUpload: _commonUpload.default
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    sendStatus: {
      type: Number,
      default: null
    },
    deliveryLog: {
      type: Object,
      default: null
    },
    customerInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    submitting: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    initiator: {
      type: String,
      default: ''
    },
    initiateTime: {
      type: String,
      default: ''
    },
    sendTaskId: {
      type: [String, Number],
      default: null
    },
    contractList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      auditing: false
    };
  },
  computed: {
    previewAttachmentList: function previewAttachmentList() {
      var _this = this;

      var data = this.form.expressSendAttachment;
      if (!data) return [];

      try {
        var raw = typeof data === 'string' ? JSON.parse(data) : data;
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        return raw.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          var name = parsed.alias || parsed.localName || parsed.realName || '';

          var isImage = _this.isImageFile(name);

          var prefix = isImage ? imgPreviewPrefix : filePreviewPrefix;
          return {
            url: parsed.url || prefix + parsed.realName,
            name: name,
            isImage: isImage
          };
        });
      } catch (_unused) {
        return [];
      }
    },
    collectionPhotoList: function collectionPhotoList() {
      var data = this.deliveryLog && this.deliveryLog.expressSendCollectionPhoto;
      if (!data) return [];

      try {
        var arr = Array.isArray(data) ? data : typeof data === 'string' ? JSON.parse(data) : [];
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        return arr.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          return {
            url: parsed.url || imgPreviewPrefix + parsed.realName,
            name: parsed.alias || parsed.localName || parsed.realName || ''
          };
        });
      } catch (_unused2) {
        return [];
      }
    }
  },
  methods: {
    // ==================== 审核方法 ====================
    handleReject: function handleReject() {
      var _this2 = this;

      if (!this.form.csAuditOpinion || !this.form.csAuditOpinion.trim()) {
        this.$message.warning('请填写您的审批意见');
        return;
      }

      this.$confirm('确定驳回该发货单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.doAudit(1011);
      }).catch(function () {});
    },
    handleApprove: function handleApprove() {
      var _this3 = this;

      this.$confirm('确定同意该发货单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.doAudit(1010);
      }).catch(function () {});
    },
    doAudit: function doAudit(status) {
      var _this4 = this;

      this.auditing = true;
      var contractNumber = this.contractList && this.contractList.length > 0 ? this.contractList[0].contractNumber || this.contractList[0].contractNo || this.contractList[0].custContractNo || '' : '';
      (0, _send.addSendTaskLog)({
        sendTaskId: this.sendTaskId,
        sendNumber: this.form.deliveryNo || '',
        contractNumber: contractNumber,
        step: String(status),
        remark: this.form.csAuditOpinion || ''
      }).then(function () {
        _this4.$message.success(status === 1011 ? '已驳回' : '已同意');

        _this4.$emit('audit-done');
      }).catch(function (error) {
        console.error('审核操作失败:', error);

        _this4.$message.error('操作失败，请重试');
      }).finally(function () {
        _this4.auditing = false;
      });
    },
    // ==================== 附件处理 ====================
    isImageFile: function isImageFile(fileName) {
      if (!fileName) return false;
      var imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'];
      var ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
      return imgExtensions.includes(ext);
    },
    downloadAttachment: function downloadAttachment(item) {
      if (item.url) {
        fetch(item.url, {
          mode: 'cors'
        }).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var a = document.createElement('a');
          a.href = blobUrl;
          a.download = item.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        }).catch(function () {
          window.open(item.url, '_blank');
        });
      }
    },
    handleAttachmentUpload: function handleAttachmentUpload(filePaths) {
      this.form.expressSendAttachment = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleAttachmentDel: function handleAttachmentDel(filePaths) {
      this.form.expressSendAttachment = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    handleCollectionUpload: function handleCollectionUpload(filePaths) {
      this.form.expressSendCollectionPhoto = JSON.stringify(filePaths);
      this.$emit('attachment-change', filePaths);
    },
    handleCollectionDel: function handleCollectionDel(filePaths) {
      this.form.expressSendCollectionPhoto = filePaths.length > 0 ? JSON.stringify(filePaths) : '';
      this.$emit('attachment-change', filePaths);
    },
    // ==================== $refs methods ====================
    fillFromEdit: function fillFromEdit(row) {
      var _this5 = this;

      if (!row) return;
      this.form.expressSendDate = row.sendDate ? typeof row.sendDate === 'string' ? row.sendDate.split(' ')[0] : row.sendDate : '';
      this.form.expressSendTime = row.sendTime || '';
      this.form.expectedDeliveryDate = row.expectedDeliveryDate || '';
      this.form.expectedDeliveryTime = row.expectedDeliveryTime || '';
      this.form.receivePerson = row.receivePerson || this.customerInfo.contactPerson || '';
      this.form.receivePhone = row.receivePhone || this.customerInfo.contactNumber || '';
      this.form.receiveAddress = row.receiveAddress || this.customerInfo.contactAddress || '';
      this.form.expressSendRemark = row.remark || '';
      this.form.expressSendAttachment = row.expressSendAttachment || row.attachment || '';
      this.form.expressSendDeliveryPerson = row.expressSendDeliveryPerson || '';
      this.form.expressSendDeliveryTime = row.expressSendDeliveryTime || '';
      this.form.expressSendCollectTime = row.expressSendCollectTime || '';
      this.form.expressSendCollectionPhoto = row.expressSendCollectionPhoto || ''; // 恢复附件

      if (row.expressSendAttachment) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('expressSendAttachment', row.expressSendAttachment);
        });
      } else if (row.attachment) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('expressSendAttachment', row.attachment);
        });
      }

      if (row.expressSendCollectionPhoto) {
        this.$nextTick(function () {
          return _this5._restoreAttachment('expressSendCollectionUpload', row.expressSendCollectionPhoto);
        });
      }
    },
    fillFromCache: function fillFromCache(saveData) {
      var _this6 = this;

      if (!saveData) return;
      if (saveData.expressSendDate) this.form.expressSendDate = saveData.expressSendDate;
      if (saveData.expressSendTime) this.form.expressSendTime = saveData.expressSendTime;
      if (saveData.expressSendRemark || saveData.remark) this.form.expressSendRemark = saveData.expressSendRemark || saveData.remark;

      if (saveData.expressSendAttachment) {
        this.form.expressSendAttachment = saveData.expressSendAttachment;
        this.$nextTick(function () {
          return _this6._restoreAttachment('expressSendAttachment', saveData.expressSendAttachment);
        });
      } else if (saveData.attachment) {
        this.form.expressSendAttachment = typeof saveData.attachment === 'string' ? saveData.attachment : JSON.stringify(saveData.attachment);
        this.$nextTick(function () {
          return _this6._restoreAttachment('expressSendAttachment', _this6.form.expressSendAttachment);
        });
      }

      if (saveData.expressSendDeliveryPerson) this.form.expressSendDeliveryPerson = saveData.expressSendDeliveryPerson;
      if (saveData.expressSendDeliveryTime) this.form.expressSendDeliveryTime = saveData.expressSendDeliveryTime;
      if (saveData.expressSendCollectTime) this.form.expressSendCollectTime = saveData.expressSendCollectTime;

      if (saveData.expressSendCollectionPhoto) {
        this.form.expressSendCollectionPhoto = saveData.expressSendCollectionPhoto;
      }
    },
    buildSaveData: function buildSaveData() {
      return {
        expressSendDate: this.form.expressSendDate,
        expressSendTime: this.form.expressSendTime,
        expressSendRemark: this.form.expressSendRemark,
        expressSendAttachment: this.form.expressSendAttachment,
        expressSendDeliveryPerson: this.form.expressSendDeliveryPerson,
        expressSendDeliveryTime: this.form.expressSendDeliveryTime,
        expressSendCollectTime: this.form.expressSendCollectTime,
        expressSendCollectionPhoto: this.form.expressSendCollectionPhoto
      };
    },
    getSubmitDataPatch: function getSubmitDataPatch(submitData) {
      submitData.sendDate = this.form.expressSendDate || '';
      submitData.sendTime = this.form.expressSendTime || '';
      submitData.receivePerson = this.form.receivePerson || '';
      submitData.receivePhone = this.form.receivePhone || '';
      submitData.receiveAddress = this.form.receiveAddress || '';
      submitData.remark = this.form.expressSendRemark || '';
      submitData.expressSendDeliveryPerson = this.form.expressSendDeliveryPerson || '';
      submitData.expressSendDeliveryTime = this.form.expressSendDeliveryTime || '';
      submitData.expressSendCollectTime = this.form.expressSendCollectTime || '';
      submitData.expressSendCollectionPhoto = this.form.expressSendCollectionPhoto || '';

      if (this.form.expressSendAttachment) {
        submitData.attachment = this.form.expressSendAttachment;
      }

      return submitData;
    },
    fillFromSendInfo: function fillFromSendInfo(row) {
      this.fillFromEdit(row);
    },
    buildDeliverySubmitPhoto: function buildDeliverySubmitPhoto() {
      var parseVal = function parseVal(v) {
        if (!v) return v;

        try {
          return JSON.parse(v);
        } catch (_unused3) {
          return v;
        }
      };

      return {
        expressSendDeliveryPerson: this.form.expressSendDeliveryPerson,
        expressSendDeliveryTime: this.form.expressSendDeliveryTime,
        expressSendCollectTime: this.form.expressSendCollectTime,
        expressSendCollectionPhoto: parseVal(this.form.expressSendCollectionPhoto)
      };
    },
    getRules: function getRules() {
      return {
        expressSendDate: [{
          required: true,
          message: '请选择期望发货日期',
          trigger: 'change'
        }],
        expressSendTime: [{
          required: true,
          message: '请选择期望发货时间',
          trigger: 'change'
        }],
        receivePerson: [{
          required: true,
          message: '请输入收货人',
          trigger: 'blur'
        }],
        receivePhone: [{
          required: true,
          message: '请输入收货人电话',
          trigger: 'blur'
        }, {
          validator: _validate.validatePhone,
          trigger: 'blur'
        }],
        receiveAddress: [{
          required: true,
          message: '收货信息必填',
          trigger: 'change'
        }]
      };
    },
    fillDeliveryInfo: function fillDeliveryInfo(deliveryLog) {
      return {
        expressSendCollectionPhoto: deliveryLog.expressSendCollectionPhoto || []
      };
    },
    // ==================== 辅助方法 ====================
    _restoreAttachment: function _restoreAttachment(refName, data) {
      var ref = this.$refs[refName];
      if (!ref) return;

      try {
        var raw = typeof data === 'string' ? JSON.parse(data) : data;
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        var files = raw.map(function (item) {
          var parsed = typeof item === 'string' ? JSON.parse(item) : item;
          var name = (parsed.alias || parsed.localName || parsed.realName || '').toLowerCase();
          var isImage = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.bmp'].some(function (e) {
            return name.endsWith(e);
          });
          var prefix = isImage ? imgPreviewPrefix : filePreviewPrefix;
          return {
            realName: parsed.realName,
            url: parsed.url || prefix + parsed.realName,
            type: parsed.type,
            alias: parsed.localName || parsed.alias
          };
        });
        ref.setFileList(files);
      } catch (e) {}
    }
  }
};
exports.default = _default2;